import Cookies from "js-cookie";

export async function getInstanceADM(client = "", model = "", token) {
  console.log("getInstanceADM called with client:", client, "model:", model);
  const api_url = Cookies.get("ApiUrl");
  const apiUrl = `${api_url}/admin/process/list/full`;
  let bodyData = {};

  // Assurez-vous que client et model ne sont pas undefined ou 'none' avant de les ajouter à bodyData
  if (model && model !== 'none') {
    bodyData.ModelId = model;
  }
  if (client && client !== 'none') {
    bodyData.ClientId = client;
  }

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(bodyData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Response data:", data);
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}
